const ELEMENTS_IN_USE = {
    wrapper: '.js--max-height-wrapper',
    example: '.js--max-height-example',
    element: '.js--max-height-element',
    wrapperHiddenClassName: 'lg-hidden',
};

function showItem() {
    const items = document.querySelectorAll(`.${ELEMENTS_IN_USE.wrapperHiddenClassName}`);
    if (items.length > 0) {
        items.forEach((item) => {
            item.classList.remove(ELEMENTS_IN_USE.wrapperHiddenClassName);
        });
    }
}

export default function maxHeight() {
    if (window.innerWidth > 1123) {
        const wrappers = document.querySelectorAll(ELEMENTS_IN_USE.wrapper);

        if (wrappers.length > 0) {
            wrappers.forEach((wrapper) => {
                const example = wrapper.querySelector(ELEMENTS_IN_USE.example);
                const element = wrapper.querySelector(ELEMENTS_IN_USE.element);

                const exampleHeight = example.offsetHeight;
                if (element) {
                    element.style.maxHeight = `${exampleHeight}px`;
                }
            });
        }

        showItem();
    }
}
